// Port de app/permissions.tsx.
import { Carregando } from "@/app/Carregando";
import EntradaDesktop from "@/components/desktop/EntradaDesktop";
import { lazy } from "react";

const PermissionsScreen = lazy(() => import("@/screens/Permissions"));

export default function PermissionsRoute() {
  return (
    // WEB: no desktop (≥1024px) a tela vai num card ao lado do painel da marca; no
    // celular o EntradaDesktop não embrulha nada.
    <EntradaDesktop>
      <Carregando cor="#294956">
        <PermissionsScreen />
      </Carregando>
    </EntradaDesktop>
  );
}
